// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/star.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Images/footer-bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container1 {
    position: relative;
    width: 100%;
    background-color: transparent;
    color: white;
    overflow: hidden;
}



.content1 {
    z-index: 200000;
}

/* .image-overlay1 {
    position: absolute;
    top: 0;
    right: 0;
    width: 80%;
    height: 100%;
    background-size: cover;
    background-position: center;
} */

/* .top-shade1,
.bottom-shade1 {
    position: absolute;
    left: 0;
    width: 100%;
    height: 30%;
    background: radial-gradient(ellipse at center, rgba(123,44,191,0.5) 0%, rgba(0,0,0,0) 70%);
    background: rgba(17, 1, 31, 1);

} */

/* .bottom-shade1 {
    position: absolute;
    width: 2934px;
    height: 487px;
    left: -696px;
    bottom: -170px;
    background: #08080A;
    filter: blur(100px);


} */

.top-shade1 {
    /* bottom: -15%; */

    position: absolute;
    width: 1779px;
    height: 516px;
    left: 57px;
    top: -350px;

    background: #11011F;
    filter: blur(100px);

}

/* .left-shade1 {
    position: absolute;
    width: 1201px;
    height: 1349.68px;
    left: -681px;
    top: -246px;

    background: #0A0A0A;
    filter: blur(45px);
} */




/* .top-left-shade {
    position: absolute;
    width: 100%;
    height: 300px;
    left: 0;
    top: -200px;
    background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));
    filter: blur(200px);
    overflow: visible;
} */

/* .bottom-right-shade {
    position: absolute;
    width: 400px;
    height: 325px;
    right: 0;
    bottom: -200px;
    background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));
    filter: blur(200px);
    z-index: 1;
} */

.bottom-right-star {
    /* position: absolute; */
    /* width: 400px; */
    /* height: 500px; */
    right: 0;
    bottom: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
    ;
    filter: blur(200px);
    overflow: visible;
    z-index: 1000;

    /* Burst-pucker-2 */
    width: 100%;
    position: absolute;
    left: 85.14%;
    right: 9.31%;
    top: 50.58%;
    bottom: 47.45%;

    background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    opacity: 0.3;

}


@media(min-width: 200px) and (max-width: 345px) {
    .left-shade1 {
        position: absolute;
        width: 1201px;
        height: 1349.68px;
        left: -681px;
        top: -246px;

        /* background: #0A0A0A; */
        background: #0A0A0A;
        filter: blur(45px);
    }

    .bottom-shade1 {
        position: absolute;
        width: 2934px;
        height: 487px;
        left: -696px;
        bottom: -170px;
        background: #08080A;
        filter: blur(100px);

    }

    .image-overlay1 {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background-size: contain;
        /* background-position: center; */
        background-repeat: no-repeat;
    }

    .container1 {
        height: 70vh;
    }

    .top-left-shade {
        position: absolute;
        width: 191px;
        height: 200px;
        left: 0;
        top: -150px;
        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));
        filter: blur(90px);
        overflow: visible;
    }   
    .bottom-right-shade {
        position: absolute;
        width: 400px;
        height: 325px;
        right: 0;
        bottom: -200px;
        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));
        filter: blur(200px);
        z-index: 1;
    }
    .footer {
        padding-top: 0vh !important;        
        padding-bottom: 0vh !important;
    }
    .Footercontact {
        margin-left:0px !important;
        padding: 2rem;
    }
    .gap-footer{
        gap: 5rem !important;
    }
    .accordianimage-icon{
        width: 2rem;
    }
}

@media(min-width: 345px) and (max-width: 567px) {
    .left-shade1 {
        display: none;
        position: absolute;
        width: 1201px;
        height: 1349.68px;
        left: -681px;
        top: -246px;

        /* background: #0A0A0A; */
        background: #0A0A0A;
        filter: blur(45px);
    }

    .bottom-shade1 {
        position: absolute;
        width: 2934px;
        height: 287px;
        left: -696px;
        bottom: -140px;
        background: #08080A;
        filter: blur(90px);


    }

    .image-overlay1 {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background-size: contain;
        /* background-position: center; */
        background-repeat: no-repeat;
    }

    .container1 {
        height: 70vh;
    }

    .top-left-shade {
        position: absolute;
        width: 100px;
        height: 200px;
        left: 0;
        top: -150px;
        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));
        filter: blur(90px);
        overflow: visible;
    }
    .bottom-right-shade {
        position: absolute;
        width: 100px;
        height: 200px;
        right: 0;
        bottom: -100px;
        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));
        filter: blur(90px);
        z-index: 1;
    }
    .footer {
        padding-top: 0vh !important;        
        padding-bottom: 0vh !important;
    }
    .Footercontact {
        margin-left:0px !important;
        padding: 2rem;
    }
    .footerllogo{
        position: absolute;
        top: -7rem;
        left:0;
    }
    
    .gap-footer{
        gap: 5rem !important;
    }
    .accordianimage-icon{
        width: 2rem;
    }
}

@media(min-width: 567px) and (max-width: 1020px) {
    .left-shade1 {
        position: absolute;
        width: 1000px;
        height: 1349.68px;
        left: -681px;
        top: -246px;
        background: #0A0A0A;
        filter: blur(45px);
    }

    .bottom-shade1 {
        position: absolute;
        width: 2934px;
        height: 287px;
        left: -696px;
        bottom: -170px;
        background: #08080A;
        filter: blur(50px);


    }
    .oval-shade {
        position: absolute;
        width: 100%;
        height: 100vh;
        filter: blur(50px);
        /* background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5)); */


    background: radial-gradient(ellipse at center, rgba(125, 24, 188, 0.3) 0%, transparent 70%);

}

    .image-overlay1 {
        position: absolute;
        top: 0;
        right: 0;
        width: 80%;
        height: 100%;
        background-size: cover;
        background-position: center;
    }

    .container1 {
        height: 100vh;
    }

    .top-left-shade {
        position: absolute;
        width: 200px;
        height: 300px;
        left: 0;
        top: -200px;
        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));
        filter: blur(120px);
        overflow: visible;
    }
    .bottom-right-shade {
        position: absolute;
        width: 400px;
        height: 325px;
        right: 0;
        bottom: -200px;
        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));
        filter: blur(200px);
        z-index: 1;
    }
    .gap-footer{
        gap: 30rem !important;
    }
}

@media(min-width: 1021px) {
    .left-shade1 {
        position: absolute;
        width: 1201px;
        height: 1349.68px;
        left: -681px;
        top: -246px;

        /* background: #0A0A0A; */
        background: #0A0A0A;
        filter: blur(45px);
    }

    .bottom-shade1 {
        position: absolute;
        width: 2934px;
        height: 300px;
        left: -696px;
        bottom: -150px;
        background: #08080A;
        filter: blur(50px);
    }

    .image-overlay1 {
        position: absolute;
        top: 0;
        right: 0;
        width: 80%;
        height: 100%;
        background-size: cover;
        background-position: center;
    }

    .container1 {
        height: 100vh;
    }

    .top-left-shade {
        position: absolute;
        width: 200px;
        height: 300px;
        left: 0;
        top: -200px;
        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));
        filter: blur(120px);
        overflow: visible;
    }
    .bottom-right-shade {
        position: absolute;
        width: 400px;
        height: 325px;
        right: 0;
        bottom: -200px;
        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));
        filter: blur(200px);
        z-index: 1;
    }
}
.gap-footer{
    gap: 50rem;
}

.accordianimage-icon{
    width: 3rem;
    cursor: pointer;
    transition: opacity 0.5s ease-in-out;
}




.footer {
    border: 1px solid rgba(15, 15, 15, 1);
    background: rgba(15, 15, 15, 1);
    padding-top: 1vh;
    padding-bottom: 5vh;
    background-size: contain;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
    position: relative;
    overflow: visible;
    opacity: 0.05px;
}`, "",{"version":3,"sources":["webpack://./src/css/BannerLayout.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;AACpB;;;;AAIA;IACI,eAAe;AACnB;;AAEA;;;;;;;;GAQG;;AAEH;;;;;;;;;GASG;;AAEH;;;;;;;;;;GAUG;;AAEH;IACI,kBAAkB;;IAElB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,UAAU;IACV,WAAW;;IAEX,mBAAmB;IACnB,mBAAmB;;AAEvB;;AAEA;;;;;;;;;GASG;;;;;AAKH;;;;;;;;;GASG;;AAEH;;;;;;;;;GASG;;AAEH;IACI,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,2EAA6D;;IAE7D,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;;IAEb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,cAAc;;IAEd,4EAA4E;IAC5E,YAAY;;AAEhB;;;AAGA;IACI;QACI,kBAAkB;QAClB,aAAa;QACb,iBAAiB;QACjB,YAAY;QACZ,WAAW;;QAEX,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,aAAa;QACb,YAAY;QACZ,cAAc;QACd,mBAAmB;QACnB,mBAAmB;;IAEvB;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,wBAAwB;QACxB,iCAAiC;QACjC,4BAA4B;IAChC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,OAAO;QACP,WAAW;QACX,oHAAoH;QACpH,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,QAAQ;QACR,cAAc;QACd,oHAAoH;QACpH,mBAAmB;QACnB,UAAU;IACd;IACA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;IACA;QACI,0BAA0B;QAC1B,aAAa;IACjB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;QACb,kBAAkB;QAClB,aAAa;QACb,iBAAiB;QACjB,YAAY;QACZ,WAAW;;QAEX,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,aAAa;QACb,YAAY;QACZ,cAAc;QACd,mBAAmB;QACnB,kBAAkB;;;IAGtB;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,wBAAwB;QACxB,iCAAiC;QACjC,4BAA4B;IAChC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,OAAO;QACP,WAAW;QACX,oHAAoH;QACpH,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,QAAQ;QACR,cAAc;QACd,oHAAoH;QACpH,kBAAkB;QAClB,UAAU;IACd;IACA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;IACA;QACI,0BAA0B;QAC1B,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,MAAM;IACV;;IAEA;QACI,oBAAoB;IACxB;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,aAAa;QACb,iBAAiB;QACjB,YAAY;QACZ,WAAW;QACX,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,aAAa;QACb,YAAY;QACZ,cAAc;QACd,mBAAmB;QACnB,kBAAkB;;;IAGtB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb,kBAAkB;QAClB,0HAA0H;;;IAG9H,2FAA2F;;AAE/F;;IAEI;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,UAAU;QACV,YAAY;QACZ,sBAAsB;QACtB,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,OAAO;QACP,WAAW;QACX,oHAAoH;QACpH,mBAAmB;QACnB,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,QAAQ;QACR,cAAc;QACd,oHAAoH;QACpH,mBAAmB;QACnB,UAAU;IACd;IACA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,aAAa;QACb,iBAAiB;QACjB,YAAY;QACZ,WAAW;;QAEX,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,aAAa;QACb,YAAY;QACZ,cAAc;QACd,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,UAAU;QACV,YAAY;QACZ,sBAAsB;QACtB,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,OAAO;QACP,WAAW;QACX,oHAAoH;QACpH,mBAAmB;QACnB,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,QAAQ;QACR,cAAc;QACd,oHAAoH;QACpH,mBAAmB;QACnB,UAAU;IACd;AACJ;AACA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oCAAoC;AACxC;;;;;AAKA;IACI,qCAAqC;IACrC,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,2EAAkE;IAClE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":[".container1 {\n    position: relative;\n    width: 100%;\n    background-color: transparent;\n    color: white;\n    overflow: hidden;\n}\n\n\n\n.content1 {\n    z-index: 200000;\n}\n\n/* .image-overlay1 {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 80%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n} */\n\n/* .top-shade1,\n.bottom-shade1 {\n    position: absolute;\n    left: 0;\n    width: 100%;\n    height: 30%;\n    background: radial-gradient(ellipse at center, rgba(123,44,191,0.5) 0%, rgba(0,0,0,0) 70%);\n    background: rgba(17, 1, 31, 1);\n\n} */\n\n/* .bottom-shade1 {\n    position: absolute;\n    width: 2934px;\n    height: 487px;\n    left: -696px;\n    bottom: -170px;\n    background: #08080A;\n    filter: blur(100px);\n\n\n} */\n\n.top-shade1 {\n    /* bottom: -15%; */\n\n    position: absolute;\n    width: 1779px;\n    height: 516px;\n    left: 57px;\n    top: -350px;\n\n    background: #11011F;\n    filter: blur(100px);\n\n}\n\n/* .left-shade1 {\n    position: absolute;\n    width: 1201px;\n    height: 1349.68px;\n    left: -681px;\n    top: -246px;\n\n    background: #0A0A0A;\n    filter: blur(45px);\n} */\n\n\n\n\n/* .top-left-shade {\n    position: absolute;\n    width: 100%;\n    height: 300px;\n    left: 0;\n    top: -200px;\n    background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));\n    filter: blur(200px);\n    overflow: visible;\n} */\n\n/* .bottom-right-shade {\n    position: absolute;\n    width: 400px;\n    height: 325px;\n    right: 0;\n    bottom: -200px;\n    background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));\n    filter: blur(200px);\n    z-index: 1;\n} */\n\n.bottom-right-star {\n    /* position: absolute; */\n    /* width: 400px; */\n    /* height: 500px; */\n    right: 0;\n    bottom: 0;\n    background: url('../Images/star.svg') no-repeat center center;\n    ;\n    filter: blur(200px);\n    overflow: visible;\n    z-index: 1000;\n\n    /* Burst-pucker-2 */\n    width: 100%;\n    position: absolute;\n    left: 85.14%;\n    right: 9.31%;\n    top: 50.58%;\n    bottom: 47.45%;\n\n    background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);\n    opacity: 0.3;\n\n}\n\n\n@media(min-width: 200px) and (max-width: 345px) {\n    .left-shade1 {\n        position: absolute;\n        width: 1201px;\n        height: 1349.68px;\n        left: -681px;\n        top: -246px;\n\n        /* background: #0A0A0A; */\n        background: #0A0A0A;\n        filter: blur(45px);\n    }\n\n    .bottom-shade1 {\n        position: absolute;\n        width: 2934px;\n        height: 487px;\n        left: -696px;\n        bottom: -170px;\n        background: #08080A;\n        filter: blur(100px);\n\n    }\n\n    .image-overlay1 {\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 100%;\n        height: 100%;\n        background-size: contain;\n        /* background-position: center; */\n        background-repeat: no-repeat;\n    }\n\n    .container1 {\n        height: 70vh;\n    }\n\n    .top-left-shade {\n        position: absolute;\n        width: 191px;\n        height: 200px;\n        left: 0;\n        top: -150px;\n        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));\n        filter: blur(90px);\n        overflow: visible;\n    }   \n    .bottom-right-shade {\n        position: absolute;\n        width: 400px;\n        height: 325px;\n        right: 0;\n        bottom: -200px;\n        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));\n        filter: blur(200px);\n        z-index: 1;\n    }\n    .footer {\n        padding-top: 0vh !important;        \n        padding-bottom: 0vh !important;\n    }\n    .Footercontact {\n        margin-left:0px !important;\n        padding: 2rem;\n    }\n    .gap-footer{\n        gap: 5rem !important;\n    }\n    .accordianimage-icon{\n        width: 2rem;\n    }\n}\n\n@media(min-width: 345px) and (max-width: 567px) {\n    .left-shade1 {\n        display: none;\n        position: absolute;\n        width: 1201px;\n        height: 1349.68px;\n        left: -681px;\n        top: -246px;\n\n        /* background: #0A0A0A; */\n        background: #0A0A0A;\n        filter: blur(45px);\n    }\n\n    .bottom-shade1 {\n        position: absolute;\n        width: 2934px;\n        height: 287px;\n        left: -696px;\n        bottom: -140px;\n        background: #08080A;\n        filter: blur(90px);\n\n\n    }\n\n    .image-overlay1 {\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 100%;\n        height: 100%;\n        background-size: contain;\n        /* background-position: center; */\n        background-repeat: no-repeat;\n    }\n\n    .container1 {\n        height: 70vh;\n    }\n\n    .top-left-shade {\n        position: absolute;\n        width: 100px;\n        height: 200px;\n        left: 0;\n        top: -150px;\n        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));\n        filter: blur(90px);\n        overflow: visible;\n    }\n    .bottom-right-shade {\n        position: absolute;\n        width: 100px;\n        height: 200px;\n        right: 0;\n        bottom: -100px;\n        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));\n        filter: blur(90px);\n        z-index: 1;\n    }\n    .footer {\n        padding-top: 0vh !important;        \n        padding-bottom: 0vh !important;\n    }\n    .Footercontact {\n        margin-left:0px !important;\n        padding: 2rem;\n    }\n    .footerllogo{\n        position: absolute;\n        top: -7rem;\n        left:0;\n    }\n    \n    .gap-footer{\n        gap: 5rem !important;\n    }\n    .accordianimage-icon{\n        width: 2rem;\n    }\n}\n\n@media(min-width: 567px) and (max-width: 1020px) {\n    .left-shade1 {\n        position: absolute;\n        width: 1000px;\n        height: 1349.68px;\n        left: -681px;\n        top: -246px;\n        background: #0A0A0A;\n        filter: blur(45px);\n    }\n\n    .bottom-shade1 {\n        position: absolute;\n        width: 2934px;\n        height: 287px;\n        left: -696px;\n        bottom: -170px;\n        background: #08080A;\n        filter: blur(50px);\n\n\n    }\n    .oval-shade {\n        position: absolute;\n        width: 100%;\n        height: 100vh;\n        filter: blur(50px);\n        /* background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5)); */\n\n\n    background: radial-gradient(ellipse at center, rgba(125, 24, 188, 0.3) 0%, transparent 70%);\n\n}\n\n    .image-overlay1 {\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 80%;\n        height: 100%;\n        background-size: cover;\n        background-position: center;\n    }\n\n    .container1 {\n        height: 100vh;\n    }\n\n    .top-left-shade {\n        position: absolute;\n        width: 200px;\n        height: 300px;\n        left: 0;\n        top: -200px;\n        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));\n        filter: blur(120px);\n        overflow: visible;\n    }\n    .bottom-right-shade {\n        position: absolute;\n        width: 400px;\n        height: 325px;\n        right: 0;\n        bottom: -200px;\n        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));\n        filter: blur(200px);\n        z-index: 1;\n    }\n    .gap-footer{\n        gap: 30rem !important;\n    }\n}\n\n@media(min-width: 1021px) {\n    .left-shade1 {\n        position: absolute;\n        width: 1201px;\n        height: 1349.68px;\n        left: -681px;\n        top: -246px;\n\n        /* background: #0A0A0A; */\n        background: #0A0A0A;\n        filter: blur(45px);\n    }\n\n    .bottom-shade1 {\n        position: absolute;\n        width: 2934px;\n        height: 300px;\n        left: -696px;\n        bottom: -150px;\n        background: #08080A;\n        filter: blur(50px);\n    }\n\n    .image-overlay1 {\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 80%;\n        height: 100%;\n        background-size: cover;\n        background-position: center;\n    }\n\n    .container1 {\n        height: 100vh;\n    }\n\n    .top-left-shade {\n        position: absolute;\n        width: 200px;\n        height: 300px;\n        left: 0;\n        top: -200px;\n        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));\n        filter: blur(120px);\n        overflow: visible;\n    }\n    .bottom-right-shade {\n        position: absolute;\n        width: 400px;\n        height: 325px;\n        right: 0;\n        bottom: -200px;\n        background-image: radial-gradient(circle, rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5), rgba(108, 23, 169, 0.5));\n        filter: blur(200px);\n        z-index: 1;\n    }\n}\n.gap-footer{\n    gap: 50rem;\n}\n\n.accordianimage-icon{\n    width: 3rem;\n    cursor: pointer;\n    transition: opacity 0.5s ease-in-out;\n}\n\n\n\n\n.footer {\n    border: 1px solid rgba(15, 15, 15, 1);\n    background: rgba(15, 15, 15, 1);\n    padding-top: 1vh;\n    padding-bottom: 5vh;\n    background-size: contain;\n    background: url('../Images/footer-bg.svg') no-repeat center center;\n    position: relative;\n    overflow: visible;\n    opacity: 0.05px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
